/* Montreal Weights — "Set Up & Train" home-gym usage LP
 * FAQ accordion, sticky-CTA reveal, scroll-reveal, smooth in-page anchors.
 * Multi-instance-safe: each section root initialised once.
 */
(function () {
  function initSection(root) {
    if (!root || root.dataset.mhgInit === '1') return;
    root.dataset.mhgInit = '1';

    /* ---------- FAQ accordion ---------- */
    var faqItems = root.querySelectorAll('.faq-item');
    faqItems.forEach(function (item) {
      var q = item.querySelector('.faq-q');
      if (!q) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        faqItems.forEach(function (i) {
          i.classList.remove('open');
          var iq = i.querySelector('.faq-q');
          if (iq) iq.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });

    /* ---------- Sticky CTA reveal after first scroll ---------- */
    var sticky = root.querySelector('.mhg-sticky');
    if (sticky) {
      var onScroll = function () { sticky.classList.toggle('on', window.scrollY > 420); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- Scroll reveal (progressive enhancement) ---------- */
    /* Only opt into the hidden→revealed animation when animations are enabled.
       Adding .reveal-on is what makes .reveal start hidden; without it (JS
       failed/blocked, or animations off) all content stays visible. */
    if (root.dataset.anim !== 'false') {
      var els = root.querySelectorAll('.reveal');
      if (!('IntersectionObserver' in window)) {
        root.classList.add('reveal-on');
        els.forEach(function (el) { el.classList.add('in'); });
      } else {
        root.classList.add('reveal-on');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        els.forEach(function (el) { io.observe(el); });
      }
    }

    /* ---------- Smooth in-page anchors ---------- */
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = this.getAttribute('href');
        if (id.length < 2) return;
        var t = document.querySelector(id);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('.mhg').forEach(initSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme-editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.mhg') : null;
    if (root) initSection(root);
  });
})();
